module.exports = __webpack_public_path__ + "static/images/wechatfind-share.ff27769.png";